<!-- 暂用于信报箱、周转柜 -->
<template>
  <div id="mqttws" class="mqttws">
    <!-- <input type="text" id="msg" v-model="msg"/> -->
    <!-- <input type="button" value="Send" @click="send(msg)" />
    <input type="button" value="Start" @click="start"/>
    <input type="button" value="Stop" @click="stop"/> -->
  </div>
</template>

<script>
  import { storage } from '../../static/turnoverCabinet/js/utility'
  import * as config from '../../static/js/config.js'
  // console.log('config', '')
  
  
  export default {
    name: 'mqttws',
    props:{
      // 订阅主题
      // topic:{
      //   type: String,
      //   // default: '/120.77.179.190/down/'+ storage.localGetItem('device_no_id') +'/get/protocol/web'
      // },
      // 发送信息
      msg:{
        type: String
      },
    },
    data() {
      return {
        hostname: config.serverPort,//地址
        port: config.mqttInfo.port,//端口号
        clientId: config.mqttInfo.clientId,//clientId（不能重复）
        userName: config.mqttInfo.userName,
        password: config.mqttInfo.password,

        // 4.0mqtt信息
        // port: 61614,//端口号
        // clientId:  config.deviceId + (new Date()).getTime(),//clientId（不能重复）
        // userName: 'admin',
        // password: 'admin',

        // 4.0smqtt信息
        // port: 61624,//端口号
        // clientId:  'PAD_' + config.deviceId,//clientId（不能重复）
        // userName: 'Terminal996',
        // password: 'Cryptogram@20',


        timeout: 5,
        keepAlive: 50,
        cleanSession: false,
        ssl: false,
        client:{},
        options: {},
      }
    },
    created : function() {
      this.onConnection();
      console.log('clientId', this.clientId)
      this.topic = '/'+ config.serverPort2 +'/down/'+ config.clientPort +'/get/protocol/web'
      console.log('server_address', config.serverPort, this.topic)
    },
    mounted : function () {
    },
    methods: {
      //开始连接
      onConnection() {
        var that = this;
        this.client = new Paho.MQTT.Client(this.hostname, this.port, this.clientId);
        var _client= this.client;
        var opt = this.options =
          {
            invocationContext: {
              host: that.hostname,
              port: that.port,
              path: _client.path,
              clientId: that.clientId
            },
            timeout: that.timeout,
            keepAliveInterval: that.keepAlive,
            cleanSession: that.cleanSession,
            useSSL: that.ssl,
            userName: that.userName,
            password: that.password,
            onSuccess: function(res) {
              console.log("连接成功",res);
              console.log('主题', that.topic)
              _client.subscribe(that.topic);//订阅主题
            },
            onFailure: function (e) {
              console.log('链接失败：',e);
              that.onConnection()
            }
          };
        this.client.connect(opt);//连接服务器并注册连接成功处理事件
        this.client.onConnectionLost = this.onConnectionLost;//注册连接断开处理事件
        this.client.onMessageArrived = this.onMessageArrived;//注册消息接收处理事件
      },
      //连接已断开
      onConnectionLost(responseObject) {
        console.log('连接已断开', responseObject)
        if (responseObject.errorCode !== 0) {
          console.log("连接已断开",responseObject.errorMessage)
        }
      },
      //收到消息
      onMessageArrived(message) {
        // console.log(message)
        // // console.log("收到消息:",message.payloadString);
        this.$emit('getMessage', JSON.parse(message.payloadString))
      },
      //订阅主题
      onConnect() {
        console.log("onConnected");
        this.client.subscribe(this.topic);//订阅主题
      },
      //发送消息
      send(msg) {
        var s = msg;
        if(s){
          // s = "{time:"+new Date().Format("yyyy-MM-dd hh:mm:ss")+", content:"+(s)+", from: web console}";
          var message = new Paho.MQTT.Message(s);
          message.destinationName = this.topic;
          console.log('send',message)
          this.client.send(message);
          // this.msg = '';//如果为空，第二次就不能发送空消息了
        }
      },
      start() {
        window.tester = window.setInterval(function(){
          if(this.client.isConnected){
            var s = this.msg;
            var message = new Paho.MQTT.Message(s);
            message.destinationName = this.topic;
            this.client.send(message);
          }
        }.bind(this), 1000);
      },
      stop() {
        window.clearInterval(window.tester);
        // this.client.disconnect();
        // console.log('已断开')
      },
      //断开mqtt
      disconnect() {
        console.log('已断开连接')
        this.client.disconnect();
      }
    },
    destroyed() {
      console.log('destroyed', '')
      this.client.disconnect();
    }
  }
</script>



// WEBPACK FOOTER //
// src/assets/mqttws2.vue